import BrandLogo from './BrandLogo'

export default BrandLogo
